<div class="trend-graph-container" [class.chart-focused]="isChartFocused">
    <div class="trend-title-header" *ngIf="!staticMode">
        <div class="trend-title">Trend</div>
        <div class="zoom-controls">
            <button class="control-btn" (click)="zoomIn()" [disabled]="isMaxZoom" title="Zoom In">+</button>
            <button class="control-btn" (click)="zoomOut()" [disabled]="isMinZoom" title="Zoom Out">−</button>
            <button class="control-btn" (click)="panLeft()" [disabled]="isLeftEdge" title="Pan Left">←</button>
            <button class="control-btn" (click)="panRight()" [disabled]="isRightEdge" title="Pan Right">→</button>
            <button class="control-btn reset-btn" (click)="resetZoom()" [disabled]="isMinZoom" title="Reset Zoom">
                Reset
            </button>
        </div>
    </div>

    <div class="chart-wrapper">
        <canvas #trendCanvas class="trend-canvas"></canvas>
    </div>
</div>
